import React from 'react';
import AIEduButton from '../common/Button/AIEduButton';
import AIEduDialog from '../common/Dialog/AIEduDialog';
import { useIntl } from 'react-intl';

const DeleteUserDialog = ({
    hideDeleteUsersDialog,
    deleteSelectedUsers,
    visible,
    title,
    deleteMessagesList = [],
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const deleteUserDialogFooter = (
        <div className='flex justify-content-end'>
            <AIEduButton
                label='Cancel'
                className='btnSecondary mr-4'
                onClick={hideDeleteUsersDialog}
            />
            <AIEduButton
                label={title}
                className={title === 'Delete' ? 'btnDelete' : 'btnPrimary'}
                onClick={deleteSelectedUsers}
            />
        </div>
    );

    const userTitle = () => {
        return (
            <div
                className='flex justify-content-between pb-2'
                style={{ borderBottom: '1px solid var(--primary-background)' }}
            >
                <div>{title === 'Delete' ? 'Delete User' : 'Update User'}</div>
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={hideDeleteUsersDialog}
                >
                    <i className='pi pi-times' />
                </div>
            </div>
        );
    };
    return (
        <AIEduDialog
            visible={visible}
            style={{ width: '40rem', fontFamily: 'SamsungOne-600, sans-serif' }}
            title={userTitle}
            footer={deleteUserDialogFooter}
            onHide={hideDeleteUsersDialog}
            content={
                <div className='flex'>
                    <i
                        className='pi pi-exclamation-triangle mr-3'
                        style={{ fontSize: '2rem' }}
                    />
                    <span>
                        {deleteMessagesList.map((message) => (
                            <div>{message}</div>
                        ))}
                    </span>
                </div>
            }
        />
    );
};

export default DeleteUserDialog;
